var app = angular.module('directives.mobilePhone');
app.directive('mobilePhone', [
    '$translate',
    'Localization',
    function($translate, PortalApi, $timeout, Localization) {
        return {
        restrict: 'E',
        scope: {
            phone: '=',
            clear: '<',
            fnc: '<',
            required: '@required',
            autocomplete: '@autocomplete',
            phonePlaceholder: '@phonePlaceholder',
            tabindex: '@tabindex',
            name: '@name'
        },
        template: require('../templates/mobilePhone.html'),
        controller: [
            '$scope',
            '$translate',
        function($scope, $translate) {
            $scope.phonePaste = function(e, paste) {
                var paste = e.originalEvent.clipboardData.getData('text/plain').replace(/[()\s+\W+]/g, ''),
                    cut;
                if (paste.length > 9) {
                    cut = paste.substring(paste.length - 9);
                    $scope.phone = cut;
                }
            }
            $scope.init = function() {
            };
            $scope.init();
        }]
    }
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/mobilePhone/directives/mobilePhone.js
 ** module id = 189
 ** module chunks = 1
 **/